import { tableTestAgentConfig, tableTestBrowserConfig, versionConfig } from "./agent-browser-dropdown";

export const testManagementColumns = [
    {
      display_name: "",
      key: "select",
      headerStyles: {
          background: "#7593F2",
          padding: "4px 8px",
          width:"50px"
        },
      cellStyles: {
          width: "auto"
        },
      _config: {
        type: "checkbox",
        displayInColumn: false,
        value: "id",
        isClickable: "true"
      }
    },
    {
      key: "displayName",
      display_name: "Test case Name",
      headerStyles: {
        background: "#7593F2",
        padding: "4px 8px",
        color: "#ffffff",
      },
      
    },
    {
      key: "version",
      display_name: "Version",
      headerStyles: {
        background: "#7593F2",
        padding: "4px 8px",
        color: "#ffffff",
      },
      _config:{
        type:"section_dropdown",
        targetKey: 'selectedVersion',
        targetOptions: 'versionList',
        componentInputs:{
          config:versionConfig,
          fields:[],
        }
      }
    },
    {
      key: "agent",
      display_name: "Execution Engine",
      headerStyles: {
        background: "#7593F2",
        padding: "4px 8px",
        color: "#ffffff",
      },
      _config:{
        type:"menu_dropdown",
        targetKey: 'selectedAgent',
        componentInputs:{
          config:tableTestAgentConfig,
          fields:[],
        }
      }
    },
    {
      key: "browser",
      display_name: "Browser",
      headerStyles: {
        background: "#7593F2",
        padding: "4px 8px",
        color: "#ffffff",
      },
      _config:{
        type:"section_dropdown",
        targetKey: 'selectedBrowser',
        componentInputs:{
          config:tableTestBrowserConfig,
          fields:[],
        }
      }
    },
  ];
  